<template>
  <LogsList :items="items" :pagination-data="paginationData" @pageChange="getData" />
</template>

<script>
import { mapGetters } from "vuex";
import apolloMixin from "@/mixins/apollo.mixin";
import LogsList from "@/views/settings/dealership-applications/index/_components/DealershipApplicationsLogsList.vue";
import { customerApplicationLogsQuery } from "@/views/settings/dealership-applications/index/gql/queries";
import DateService from "@/services/date.service";

export default {
  name: "DealershipApplicationsLogsPanel",

  components: { LogsList },

  mixins: [apolloMixin],

  data() {
    return {
      items: [],
      paginationData: {},
    };
  },

  computed: {
    ...mapGetters("dealershipApplications", ["getStatus"]),
  },

  created() {
    this.getData();
  },

  methods: {
    async getData(page = parseInt(this.$route.query.page, 10) || 1) {
      const { customerApplicationLogs } = await this.$get(customerApplicationLogsQuery, {
        customerApplicationId: this.$route.params.id,
        page,
        perPage: 20,
      });

      this.items = customerApplicationLogs.data.map((application) => {
        const { id, eventTypeLabel, comment, statusAtEvent, userFullName, userEmail, createdAt } =
          application;

        return {
          id,
          eventTypeLabel,
          comment,
          statusAtEvent,
          userData: {
            fullName: userFullName,
            email: userEmail,
          },
          userFullName,
          userEmail,
          createdAt: DateService.dateConverter(createdAt, "datetime"),
        };
      });

      this.paginationData = customerApplicationLogs.paginatorInfo;
    },
  },
};
</script>
